class PendoHelper {
	static load() {
		let apiKey = process.env.REACT_APP_PENDO_KEY;
		(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
			v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
				o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
			y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
			z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);}
		)(window,document,'script','pendo');
	}

	static initialize(authenticatedUser) {
		// eslint-disable-next-line no-undef
		if (pendo && authenticatedUser && !authenticatedUser.ghosting) {
			// eslint-disable-next-line no-undef
			pendo.initialize({
				visitor: {
					id: `ssi-${authenticatedUser.id}`, // Required if user is logged in
					email: authenticatedUser.email, // Recommended if using Pendo Feedback, or NPS Email
					full_name: authenticatedUser.name, // Recommended if using Pendo Feedback
					role: authenticatedUser.title // Optional

					// You can add any additional visitor level key-values here,
					// as long as it's not one of the above reserved names.
				},

				account: {
					id: `ssi-${authenticatedUser.accountId}`, // Highly recommended
					name: authenticatedUser.accountName, // Optional
					NavID: authenticatedUser.navId
					// is_paying: // Recommended if using Pendo Feedback
					// monthly_value: // Recommended if using Pendo Feedback
					// planLevel: // Optional
					// planPrice: // Optional
					// creationDate: // Optional

					// You can add any additional account level key-values here,
					// as long as it's not one of the above reserved names.
				}
			});
		}
	}

	static loadAccessibe() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
        script.onload = () => {
          console.log("AccessiBe script loaded");
          PendoHelper.initializeAccessibe();
        };
        script.onerror = () => {
          console.error("Error loading AccessiBe script");
        };
        document.head.appendChild(script);
      }

      static initializeAccessibe() {
        if (window.acsbJS) {
          window.acsbJS.init({
            statementLink: '', 
            footerHtml: '', 
            hideMobile: false, 
            hideTrigger: false, 
            disableBgProcess: false, 
            language: 'en', 
            position: 'left', 
            leadColor: '#4A1FB8', 
            triggerColor: '#4A21B8', 
            triggerRadius: '50%', 
            triggerPositionX: 'left', 
            triggerPositionY: 'bottom', 
            triggerIcon: 'people', 
            triggerSize: 'medium', 
            triggerOffsetX: 20, 
            triggerOffsetY: 20, 
            mobile: {
                triggerSize: 'small', 
                triggerPositionX: 'right', 
                triggerPositionY: 'bottom', 
                triggerOffsetX: 10, 
                triggerOffsetY: 10, 
                triggerRadius: '50%'
        },
          });
          console.log("AccessiBe initialized");
        } else {
          console.error("AccessiBe script did not load correctly");
        }
      }
}

export default PendoHelper;